import {IDENTIFIER_TYPE_TO_INPUT_LABEL, BSN, ORGANIZATION_TYPES} from 'constants.js';
import dayjs from 'dayjs';

export const computeRestrictions = (restrictions, isActive) =>
  restrictions ? restrictions.filter((restriction) => restriction.isActive === isActive) : [];

export const computeAllowanceTypeText = (allowanceType, isAllowed) =>
  `${allowanceType} is ${isAllowed ? '' : 'not'} allowed`;

export const computeRestrictionTypeText = (restrictionType, isRestricted) =>
  `${restrictionType} is ${isRestricted ? '' : 'not'} restricted`;

export const formatOrganizationTypes = (types) => types.map((type) => ORGANIZATION_TYPES[type]).join(', ');

export const sortByFieldName = (arr, fieldName, reverse) => 
  arr.slice().sort((a, b) => {
    const lesser = reverse ? 1 : -1;
    const greater = reverse ? -1 : 1;
    const equal = 0;
    return a[fieldName] > b[fieldName] ? greater : a[fieldName] < b[fieldName] ? lesser : equal;
  });

export const formatDateTimeWithTimezone = (isoDate) => {
  return dayjs(isoDate).format('MMMM D, YYYY HH:mm (UTCZ)');
};

export const constructIdentifiers = (identifiers) => {
  return identifiers.map((identifier) => {
    return {
      system: `${identifier.system} (${IDENTIFIER_TYPE_TO_INPUT_LABEL[identifier.system] || ''})`,
      value: identifier.value
    };
  });
};

export const constructPatientIdentifiers = (identifiers, hasBsnIdentifier) => {
  const formattedIdentifiers = constructIdentifiers(identifiers);

  if (hasBsnIdentifier) {
    formattedIdentifiers.push({
      system: `${BSN.id} (BSN)`,
      value: '<Redacted>'
    });
  }

  return formattedIdentifiers;
};

export const filterRestrictionsOfType = (restrictions, restrictionType) =>
  restrictions?.filter((restriction) => restriction.code !== restrictionType) || [];
